import { useEffect, useState } from 'react';

// matchMedia is absent in jsdom and in any non-browser render target, so a
// missing implementation must degrade to "does not match" rather than throw.
const getQuery = (query) =>
  typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(query)
    : null;

/** Subscribes to a CSS media query. */
export default function useMediaQuery(query) {
  const [matches, setMatches] = useState(() => getQuery(query)?.matches ?? false);

  useEffect(() => {
    const mql = getQuery(query);
    if (!mql) return undefined;
    setMatches(mql.matches);
    const onChange = (e) => setMatches(e.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}

export const MOBILE_QUERY = '(max-width: 768px)';
